// extracted by mini-css-extract-plugin
export default {"counter":"StatsCounter_counter__eycPV","number":"StatsCounter_number__V01TQ"};